import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Select from "@mui/material/Select";
import {
    BootstrapInput,
    BootstrapFormControl,
    CustomMenuItem,
} from "./StyledForm";

const DropdownMenu = ({
    options,
    display,
    val,
    label,
    formlabel,
    onChange,
    value,
}) => {
    return (
        <BootstrapFormControl display={display}>
            {formlabel !== undefined ? <FormLabel>{formlabel}</FormLabel> : ``}
            <Select
                value={value}
                onChange={onChange}
                input={<BootstrapInput display={display} />}
            >
                {options.map((option) => (
                    <CustomMenuItem key={option[val]} value={option[val]}>
                        {option[label]}
                    </CustomMenuItem>
                ))}
            </Select>
        </BootstrapFormControl>
    );
};

export default DropdownMenu;
